import PropTypes from 'prop-types'
import { pick } from 'ramda'

import { regexPropType } from '~/src/Lib/PropTypes'

export * from './logger'
export * from './query'
export * from './state'

export const selectedZoneType = PropTypes.oneOfType([PropTypes.number, regexPropType(/room/)])

export const getTransferableState = pick([
  'activeAnnotationTypes',
  'chartTimeframe',
  'individualGraphs',
  'individualSensors',
  'journalOpen',
  'manualFrom',
  'manualTo',
  'selectedDataTypes',
  'showRoomAvg',
  'showYAxis',
  'splitGraphs'
])
